// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1ExCl","title":"Info_title__tm3nU","links":"Info_links__PEsVR","link":"Info_link__3EDSn","logo":"Info_logo__2fT7h"};